import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { addPricingTier } from '../../utils/api/pricingTier';

function AddPricingTierModal({ show, onClose }) {
  const [formData, setFormData] = useState({
    label: '',
    minMinutes: '',
    maxMinutes: '',
    ratePerMinute: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { label, minMinutes, maxMinutes, ratePerMinute } = formData;
    if (!label || !minMinutes || !maxMinutes || !ratePerMinute) {
      toast.error('Please fill all required fields.');
      return;
    }

    setLoading(true);
    try {
      await addPricingTier({
        ...formData
   
      });

      toast.success("Pricing tier added successfully!");
      onClose();
    } catch (error) {
      console.error("Error adding pricing tier:", error);
      toast.error("Failed to add pricing tier");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <motion.div
      className="modal fade show"
      tabIndex="-1"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.6)',
        backdropFilter: 'blur(4px)',
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{
          borderRadius: '16px',
          border: 'none',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        }}>
          <div className="modal-header">
            <h6 className="modal-title">Add Pricing Tier</h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row g-3">

                <div className="col-md-12">
                  <label className="form-label fw-semibold">Label*</label>
                  <input
                    type="text"
                    name="label"
                    className="form-control"
                    value={formData.label}
                    onChange={handleChange}
                    required
                    placeholder="e.g., Startup, Pro"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Minimum Minutes*</label>
                  <input
                    type="number"
                    name="minMinutes"
                    className="form-control"
                    value={formData.minMinutes}
                    onChange={handleChange}
                    min={0}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Maximum Minutes*</label>
                  <input
                    type="number"
                    name="maxMinutes"
                    className="form-control"
                    value={formData.maxMinutes}
                    onChange={handleChange}
                    min={1}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label fw-semibold">Rate Per Minute (₹)*</label>
                  <input
                    type="number"
                    step="0.01"
                    name="ratePerMinute"
                    className="form-control"
                    value={formData.ratePerMinute}
                    onChange={handleChange}
                    min={0.01}
                    required
                    placeholder="e.g., 2.5"
                  />
                </div>

              </div>
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Add Pricing Tier'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </motion.div>
  );
}

export default AddPricingTierModal;
